import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'
import { Description } from '../../Shared.styles'
import Icon from 'components/common/Icon/Icon'

const BOTServiceCategoriesStatePage = ({ title, description, serviceCategories: { serviceCategories }}) =>
  <Wrapper>
    <Overlay>
      <Title>{ title }</Title>
      <CustomDescription>{ description }</CustomDescription>
      <Services>
        { serviceCategories.map(item =>
          <Service key={ item.categoryName }>
            <Container>
              <Icon asset={ item.iconName } height={ 80 } width={ 80 } />
            </Container>
            <ServiceName to={ item.serviceCategorySeo }>{ item.categoryName }</ServiceName>
          </Service>
        )}
      </Services>
    </Overlay>
  </Wrapper>

BOTServiceCategoriesStatePage.propTypes = {
  description: PropTypes.string,
  serviceCategories: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

export default BOTServiceCategoriesStatePage

const Wrapper = styled.div`
  background: ${props => `url(${props.image})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: 60px;
`

const Overlay = styled.div`
  background-color: #8b1418;
  padding: 50px 20px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
`

const Title = styled.h2`
  text-align: center;
  color: #fff;
  font-size: 26px;
  text-transform: uppercase;
  transform: scale(1, 1.3);
  font-weight: 700;
`

const CustomDescription = styled(Description)`
  color: #fff;
  font-size: 16px;
`

const Services = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  column-gap: 20px;
  row-gap: 20px;
  ${Media.mobile`
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  `}
`

const Service = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const ServiceName = styled(Link)`
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  transform: scale(1, 1.2);
  color: #fff;
  cursor: pointer;
  text-transform: uppercase;
`

const Container = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`
